export default "__VITE_ASSET__25d51549__"